// 价格含有区间价/一口价/阶梯价
import * as React from 'react';
import { Icon } from '@alifd/next';
import {useAppSelector} from '../../redux/hooks'
import './index.scss';

function ProductTitle ( props: any ) {
  const { product,seller, promoConfig } = props;
  const {labels = []} = product;
  const leadTime = useAppSelector(state => state.sku.goods.leadTime);
  
  const renderLeadTime = () => {
    if (product?.productIsHang) return null;
    if (leadTime > 0 && leadTime <= 15) {
      return <div className='lead-time'>
              <div className="pre-icon">
                Ready to Ship
              </div>
              <div className="icon-ins">
                <Icon type='success' size='xs' />In Stock 
                <Icon type='success' size='xs' />Fast Dispatch
              </div>
      </div>
    }
  }

  const promotionInfo = JSON.parse(promoConfig);
  
  return (
    <div className="product-title">
      {renderLeadTime()}
      {seller?.sellerSelfOperated && <img src="https://img.alicdn.com/tfs/TB1CstoKoY1gK0jSZFCXXcwqXXa-111-21.svg" />}
      <h1>
        {promotionInfo?.DETAIL_TITLE_PREPEND_ATOMOSPHERE?.length > 0 && <img style={{
          height: "16px"
        }} src={promotionInfo?.DETAIL_TITLE_PREPEND_ATOMOSPHERE[0]?.materialJSON?.image} />}
        {product?.subject}
        <span id="title-tag"></span>
        {labels.length > 0 && labels.map((i:string) => <span className='label-item'>{i}</span>)}
      </h1>
    </div>
  );
}

export default ProductTitle;
